module.exports = __webpack_public_path__ + "static/img/6004_phase_function_Paper_Points.fd0e576.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6004_phase_function_Paper_Points.png
// module id = 4pdn
// module chunks = 0